import React, { useCallback } from 'react'
import FormEmail from '../FormEmail'
import FormPhone from '../FormPhone'
import styles from './styles.module.css'
import { classNames } from '@monorepo/utils'
import { TabValue } from '../../constants'
import { useTranslation } from 'react-i18next'

interface LoginProps {
  activeTab: TabValue,
  setActiveTab: (tab: TabValue) => void,
}

export const LoginForm: React.FC<React.PropsWithChildren<LoginProps>> = ({ children, activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  const handleChangeTab = useCallback((tab: TabValue) => setActiveTab(tab), [])

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        <div
          className={classNames(styles.tab, activeTab === TabValue.Phone && styles.activeTab)}
          onClick={() => handleChangeTab(TabValue.Phone)}
        >
          {t('form.toggle.phone')}
        </div>
        <div
          className={classNames(styles.tab, activeTab === TabValue.Email && styles.activeTab)}
          onClick={() => handleChangeTab(TabValue.Email)}
        >
          {t('form.toggle.email')}
        </div>
      </div>
      {activeTab === TabValue.Email && <FormEmail>{children}</FormEmail>}
      {activeTab === TabValue.Phone && <FormPhone>{children}</FormPhone>}
    </div>
  )
}
